var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"drum-pad",attrs:{"id":_vm.btnId},on:{"click":_vm.play,"keyup":_vm.keyPressed}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('audio',{staticClass:"clip",attrs:{"src":_vm.url,"id":_vm.audioID}})])}
var staticRenderFns = []

export { render, staticRenderFns }